import { AppButton } from './AppButton'
import { cn } from '@/utils/cn'

export type WizardNavFooterProps = {
  onBack?: () => void
  onNext?: () => void
  backLabel?: string
  nextLabel?: string
  nextDisabled?: boolean
  nextLoading?: boolean
  className?: string
}

export function WizardNavFooter({
  onBack,
  onNext,
  backLabel = 'Back',
  nextLabel = 'Next',
  nextDisabled,
  nextLoading,
  className,
}: WizardNavFooterProps) {
  return (
    <div
      className={cn(
        'flex w-full flex-col-reverse gap-2.5 sm:flex-row sm:justify-end',
        className
      )}
    >
      {onBack ? (
        <AppButton
          variant="outline"
          onClick={onBack}
          className="w-full sm:w-auto sm:min-w-[140px]"
        >
          {backLabel}
        </AppButton>
      ) : null}
      {onNext ? (
        <AppButton
          onClick={onNext}
          disabled={nextDisabled}
          loading={nextLoading}
          className="w-full sm:w-auto sm:min-w-[220px]"
        >
          {nextLabel}
        </AppButton>
      ) : null}
    </div>
  )
}
